import { Fragment } from 'react'
import { runOperator } from '.'

export const OperatorWrapper = (props: any) => {
  const { field, values } = props

  const { disabled, hidden } = runOperator(field, { row: values })

  return <Fragment>{props.children({ disabled, hidden })}</Fragment>
}
